var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.article.brand)?_c('p',{staticClass:"product-brand"},[_vm._v(" "+_vm._s(_vm.article.brand.name)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }